{
	"loading": "Loading the board…",
	"loadError": "The board could not load. Try again.",
	"dnd": {
		"card": "card",
		"picked": "Picked up card {{title}}.",
		"over": "Over a column.",
		"nowhere": "Not over a column.",
		"dropped": "Card dropped.",
		"cancelled": "Move cancelled.",
		"instructions": "To move a card, press Space, use the arrow keys, then Space to drop it or Escape to cancel."
	},
	"column": {
		"name": "Column name",
		"menu": "Options for {{name}}",
		"rename": "Rename",
		"moveLeft": "Move left",
		"moveRight": "Move right",
		"color": "Colour",
		"delete": "Delete column",
		"deleteTitle": "Delete “{{name}}”?",
		"deleteBody": "Only an empty column can be deleted. Move or delete its cards first.",
		"add": "Add column",
		"newName": "New column",
		"showMore": "Show more cards",
		"loadingMore": "Loading…"
	},
	"colors": {
		"GRAY": "Grey",
		"BLUE": "Blue",
		"GREEN": "Green",
		"YELLOW": "Yellow",
		"ORANGE": "Orange",
		"RED": "Red",
		"PURPLE": "Purple",
		"PINK": "Pink",
		"BROWN": "Brown",
		"AMBER": "Amber",
		"LIME": "Lime",
		"TEAL": "Teal",
		"CYAN": "Cyan",
		"SKY": "Sky",
		"INDIGO": "Indigo",
		"VIOLET": "Violet",
		"ROSE": "Rose",
		"SLATE": "Slate",
		"custom": "Custom {{hex}}",
		"customLabel": "Custom colour",
		"customPick": "Pick a custom colour",
		"pick": "Colour"
	},
	"card": {
		"add": "New card",
		"untitled": "Untitled",
		"title": "Card title",
		"close": "Close",
		"loadError": "This card could not load. It may have been deleted.",
		"assignee": "Assignee",
		"unassigned": "Nobody",
		"due": "Due date",
		"labels": "Labels",
		"labelsTooMany": "At most {{max}} labels, each up to {{length}} characters.",
		"description": "Description",
		"descriptionPlaceholder": "Add details, a checklist, links…",
		"meta": "Created by {{created}} · last edited by {{updated}}, {{time}}",
		"save": "Save",
		"cancel": "Cancel",
		"delete": "Delete card",
		"deleteTitle": "Delete this card?",
		"deleteBody": "“{{title}}” is deleted. This cannot be undone.",
		"open": "Open card",
		"status": "Status",
		"moreAssignees": "+{{count}}",
		"openAsPage": "Open as page",
		"backToBoard": "Back to the board",
		"breadcrumbs": "Where this card is",
		"saved": "Card saved",
		"more": "More actions",
		"unsaved": "Unsaved changes",
		"saveKey": "Ctrl Enter",
		"addLabel": "Add a label…",
		"removeLabel": "Remove label {{label}}",
		"discardTitle": "Discard unsaved changes?",
		"discardBody": "Your edits to this card have not been saved. Closing it now loses them.",
		"discard": "Discard",
		"keepEditing": "Keep editing",
		"moveTo": "Move to"
	},
	"toolbar": {
		"search": "Search cards",
		"clearSearch": "Clear search",
		"noMatches": "No card matches “{{q}}”.",
		"filter": "Filter",
		"filterCount_one": "{{count}} filter",
		"filterCount_other": "{{count}} filters",
		"sort": "Sort",
		"properties": "Properties",
		"noFilters": "No filters yet. Every card shows.",
		"addFilter": "Add a filter",
		"removeFilter": "Remove filter",
		"where": "Where",
		"and": "And",
		"filterGone": "This filter used a property that was deleted. It no longer applies.",
		"field": "Field",
		"operator": "Condition",
		"value": "Value",
		"pick": "Pick…",
		"valuePlaceholder": "Type a value",
		"builtIn": "Card",
		"boardProperties": "Properties",
		"fields": {
			"TITLE": "Title",
			"ASSIGNEE": "Assignee",
			"DUE_DATE": "Due date",
			"LABELS": "Labels",
			"CREATED_AT": "Created",
			"UPDATED_AT": "Last edited",
			"PROPERTY": "Property"
		},
		"ops": {
			"CONTAINS": "contains",
			"NOT_CONTAINS": "does not contain",
			"IS": "is",
			"IS_NOT": "is not",
			"IS_EMPTY": "is empty",
			"IS_NOT_EMPTY": "is not empty",
			"GT": "greater than",
			"LT": "less than",
			"GTE": "at least",
			"LTE": "at most",
			"BEFORE": "is before",
			"AFTER": "is after",
			"IS_CHECKED": "is ticked",
			"IS_NOT_CHECKED": "is not ticked"
		},
		"sharedHint": "Filters and sort are saved for everyone on this board. Search is just for you.",
		"sortBy": "Sort by",
		"direction": "Direction",
		"asc": "Ascending",
		"desc": "Descending",
		"sortFields": {
			"MANUAL": "Manual (drag to order)",
			"TITLE": "Title",
			"DUE_DATE": "Due date",
			"CREATED_AT": "Created",
			"UPDATED_AT": "Last edited"
		},
		"manualHint": "Cards keep the order you drag them into.",
		"sortedHint": "Cards are in this order in every column. Dragging a card moves it to another column only.",
		"groupBy": "Group: {{name}}",
		"groupTitle": "Group by",
		"groupHint": "Only you see this grouping. Drag a card to another column to change its value."
	},
	"properties": {
		"title": "Properties",
		"close": "Close properties",
		"shared": "Properties are shared by every board. A change here shows everywhere.",
		"onCards": "Show on cards",
		"builtIn": {
			"ASSIGNEE": "Assignee",
			"DUE_DATE": "Due date",
			"LABELS": "Labels"
		},
		"show": "Show {{name}} on cards",
		"hide": "Hide {{name}} on cards",
		"edit": "Edit property",
		"moveUp": "Move {{name}} up",
		"moveDown": "Move {{name}} down",
		"delete": "Delete {{name}}",
		"deleteTitle": "Delete the property “{{name}}”?",
		"deleteBody": "It leaves every board, and every card on every board loses its value for it. Filters and a sort that use it stop applying. This cannot be undone.",
		"deleteConfirm": "Delete property",
		"add": "Add a property",
		"editNamed": "Edit property {{name}}",
		"saveCardFirst": "Save the card first to edit this property",
		"retype": {
			"none": "No card has a value yet — nothing changes on the cards.",
			"keeps_one": "{{count}} card keeps its value (converted).",
			"keeps_other": "{{count}} cards keep their values (converted).",
			"clears_one": "{{count}} card loses its value for this property.",
			"clears_other": "{{count}} cards lose their values for this property.",
			"confirm": "Change type and clear values"
		},
		"create": "Add property",
		"name": "Name",
		"namePlaceholder": "e.g. Priority, Venue, Points",
		"type": "Type",
		"types": {
			"TEXT": "Text",
			"NUMBER": "Number",
			"SELECT": "Select",
			"MULTI_SELECT": "Multi-select",
			"DATE": "Date",
			"PERSON": "Person",
			"CHECKBOX": "Checkbox",
			"URL": "URL",
			"EMAIL": "Email",
			"PHONE": "Phone"
		},
		"typeHints": {
			"TEXT": "Any text",
			"NUMBER": "A number, sortable",
			"SELECT": "One option from a list",
			"MULTI_SELECT": "Several options from a list",
			"DATE": "A calendar day",
			"PERSON": "A super admin",
			"CHECKBOX": "Yes or no",
			"URL": "A web link",
			"EMAIL": "An email address",
			"PHONE": "A phone number"
		},
		"options": "Options",
		"optionName": "Option name",
		"newOption": "New option",
		"addOption": "Add option",
		"removeOption": "Remove {{name}}",
		"removedHint": "Removed options are cleared from every card when you save.",
		"colorIs": "Colour: {{color}} (click to change)",
		"back": "Back",
		"save": "Save",
		"empty": "Empty",
		"noOptions": "No options yet. Add some in Properties.",
		"checked": "Yes",
		"unchecked": "No",
		"unknownPerson": "Someone"
	},
	"comments": {
		"title": "Comments",
		"count_one": "{{count}} comment",
		"count_other": "{{count}} comments",
		"empty": "No comments yet.",
		"placeholder": "Add a comment…",
		"send": "Comment",
		"sendKey": "Ctrl Enter",
		"label": "Comment",
		"earlier": "Show earlier comments",
		"edited": "edited",
		"edit": "Edit",
		"save": "Save",
		"cancel": "Cancel",
		"delete": "Delete",
		"deleteTitle": "Delete this comment?",
		"deleteBody": "Delete this comment for everyone? This cannot be undone.",
		"tooLong": "A comment can be at most {{max}} characters.",
		"unknownAuthor": "Deleted user",
		"loadError": "Comments could not load. Try again.",
		"actions": "Comment actions"
	},
	"group": {
		"none": "No {{name}}"
	}
}
